module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "rqa gv-color-scheme"
  }, [_vm._c('div', {
    staticClass: "rqa-title gv-color-scheme"
  }, [_vm._v("\n    Rete Qualità Aria - Indicatori annuali e giornalieri\n    "), _vm._c('button', {
    class: _vm.toggleCollapseClass(),
    attrs: {
      "size": "mini",
      "title": "Nascondi Pannello"
    },
    on: {
      "click": _vm.hidePanel
    }
  }), _vm._v(" "), _vm._c('button', {
    staticClass: "gv-color-scheme rqa-download-button el-icon-download",
    attrs: {
      "id": "rqa-download-button",
      "title": "Download Dati",
      "size": "mini"
    },
    on: {
      "click": _vm.download
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "rqa-wrapper gv-color-scheme",
    attrs: {
      "id": "rqa-wrapper"
    }
  }, [_vm._c('div', {
    staticClass: "combo"
  }, [_vm._c('el-select', {
    attrs: {
      "placeholder": "Seleziona Annuali/Giornalieri",
      "size": "mini"
    },
    on: {
      "change": _vm.onChangeTipo
    },
    model: {
      value: (_vm.tipo),
      callback: function($$v) {
        _vm.tipo = $$v
      },
      expression: "tipo"
    }
  }, _vm._l((_vm.tipi), function(item) {
    return _vm._c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  }))], 1), _vm._v(" "), _vm._c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIndicatoriGiorno),
      expression: "showIndicatoriGiorno"
    }],
    staticClass: "combo"
  }, [_vm._c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Seleziona Inquinante e Indicatore",
      "size": "mini"
    },
    on: {
      "change": _vm.onChangeIndicatore
    },
    model: {
      value: (_vm.indicatore),
      callback: function($$v) {
        _vm.indicatore = $$v
      },
      expression: "indicatore"
    }
  }, _vm._l((_vm.indicatoriGiorno), function(item) {
    return _vm._c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.nome
      }
    })
  }))], 1), _vm._v(" "), _vm._c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIndicatoriGiorno),
      expression: "showIndicatoriGiorno"
    }],
    staticClass: "combo"
  }, [_vm._c('el-date-picker', {
    attrs: {
      "size": "mini",
      "type": "date",
      "placeholder": "Seleziona Giorno",
      "picker-options": _vm.datePickerOptions,
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.giorno),
      callback: function($$v) {
        _vm.giorno = $$v
      },
      expression: "giorno"
    }
  })], 1), _vm._v(" "), _vm._c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIndicatoriAnno),
      expression: "showIndicatoriAnno"
    }],
    staticClass: "combo"
  }, [_vm._c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Seleziona Inquinante e Indicatore",
      "size": "mini"
    },
    on: {
      "change": _vm.onChangeIndicatore
    },
    model: {
      value: (_vm.indicatore),
      callback: function($$v) {
        _vm.indicatore = $$v
      },
      expression: "indicatore"
    }
  }, _vm._l((_vm.indicatoriAnno), function(item) {
    return _vm._c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.nome
      }
    })
  }))], 1), _vm._v(" "), _vm._c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIndicatoriAnno),
      expression: "showIndicatoriAnno"
    }],
    staticClass: "combo"
  }, [_vm._c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Seleziona Anno",
      "size": "mini"
    },
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  }, _vm._l((_vm.anni), function(item) {
    return _vm._c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  }))], 1), _vm._v(" "), _vm._c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLegend),
      expression: "showLegend"
    }]
  }, [_vm._c('gv-iframe-panel', {
    staticClass: "gv-iframe-panel",
    attrs: {
      "src": _vm.legendUrl,
      "height": "141",
      "width": "230"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a6df0c7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RqaLivelli.vue
// module id = 861
// module chunks = 39